angular.module('igsSolarOps')
.directive('dropdownMultiselect', function () {
    return {
        restrict: 'E',
        scope: {
            model: '=',
            options: '=',
            ddstyle: '=',
            display: '@',
            singulartext: '@',
            pluraltext: '@',
            comparator: '@',
            modelcomparator: '@',
            optioncomparator: '@',
            showif: '@',
            disabledif: '=',
            change: '&',
            uniqueid: '@',
            defaultstate: '@',
            maxselected: '@',
            closeonmaxselected: '@',
            optionitem: '@',
            singleselect: '@',
            close: '&'
        },
        template: 
            '<div class="dropdownmenucontainer" id="{{uniqueid}}">' +
                '<button type="button" class="ui-multiselect ui-widget ui-state-default ui-corner-all" ng-click="buttonClick($event)" style="padding-right:10px;" ng-style="ddstyle" ng-disabled="$eval(disabledif)">' +
                    '<div><span class="ui-icon ui-icon-triangle-2-n-s"></span><span ng-bind="getDisplayValue()"></span></div>' +
                '</button>' +
                '<div style="display:block;height:0px;overflow:visible;z-index:1000;position:relative;">' +
                    '<div style="max-height:200px; overflow-y:auto;margin:0px;border-width:1px;border-style:solid;border-color:#ddd;" ng-if="showDropDown==true" ng-style="dropdownStyle">' +
                        '<table id="dropdown" style="margin:0px; table-layout: fixed;width: 100%;word-wrap: break-word; background-color:white;">' +
                            '<tbody data-ng-repeat="option in options" ng-if="showif == null || $eval(showif)">' +
                                '<tr>' +
                                    '<td>' +
                                        '<input type="checkbox" ng-click="setSelectedItem($eval(getOptionItem()))" ng-checked="isChecked($eval(getOptionItem()))" style="display:inline; margin-right: 3px;">' +
                                        '<div ng-bind="$eval(getDisplayExpression())" style="display:inline;cursor:pointer;" ng-click="setSelectedItem($eval(getOptionItem()))"></div>' +
                                    '</td>' +
                                '</tr>' +
                            '</tbody>' +
                        '</table>' +
                    '</div>' +
                '</div>' +
            '</div>',

        controller: function ($scope, $timeout, $parse) {
            $scope.dropdownStyle = { 'width' : 'auto'};
            $scope.showDropDown = false;
            $scope.useRandomId = true; //without using random ids, opening and closing multiple dropdowns can give an odd effect with multiple dropdown multiselects (another option is using a reserved class)
            $scope.notArray = false;
            $scope.useCustomCompare = false;
            $scope.useModelCompare = false;
            $scope.useOptionCompare = false;
            $scope.useOptionItem = false;
            $scope.useDisplayOption = false;

            if (typeof $scope.comparator !== 'undefined' && $scope.comparator != null) {
                $scope.useCustomCompare = true;
            }

            if (typeof $scope.modelcomparator !== 'undefined' && $scope.modelcomparator != null) {
                $scope.useModelCompare = true;
            }

            if (typeof $scope.optioncomparator !== 'undefined' && $scope.optioncomparator != null) {
                $scope.useOptionCompare = true;
            }

            if (typeof $scope.singleselect !== 'undefined' && $scope.singleselect != null && ($scope.singleselect == true || $scope.singleselect == 'true')) {
                $scope.notArray = true;
            }

            if (typeof $scope.optionitem !== 'undefined' && $scope.optionitem != null && $scope.optionitem != '') {
                $scope.useOptionItem = true;
            }

            if (typeof $scope.display !== 'undefined' || $scope.display != null || $scope.display != '') {
                $scope.useDisplayOption = true;
            }

            $scope.getOptionItem = function() {
                return $scope.useOptionItem ? $scope.optionitem : 'option';
            }

            $scope.getDisplayValue = function() {
                var tempSignularText = '';
                var tempPluralText = '';
                if (typeof $scope.singulartext !== 'undefined' && $scope.singulartext != null) {
                    tempSignularText = $scope.singulartext;
                }
                if (typeof $scope.pluraltext !== 'undefined' && $scope.pluraltext != null) {
                    tempPluralText = $scope.pluraltext;
                }
                var defaultTitle = 'All';
                if (typeof $scope.defaultstate !== 'undefined' && $scope.defaultstate != null) {
                    defaultTitle = $scope.defaultstate;
                }

                if ($scope.notArray == false) {
                    if (typeof $scope.model === 'undefined' || $scope.model == null || $scope.model.length == 0) return defaultTitle + ' ' + tempPluralText;

                    var outputItems = [];
                    var optionExp = $scope.getOptionItem();
                    var displayExp = $scope.getDisplayExpression();

                    for (var y = 0; y < $scope.model.length; y++) {
                        for (var x = 0; x < $scope.options.length; x++) {
                            $scope.option = $scope.options[x];
                            if ($scope.compare($scope.model[y], $parse(optionExp)($scope))) {
                                outputItems.push($parse(displayExp)($scope));
                            }
                            outputItems.push();
                        }
                    }

                    if (outputItems.length == 1) return outputItems[0];
                    return $scope.model.length + ' ' + tempPluralText;

                } else {
                    if ($scope.model == null) {
                        return defaultTitle + ' ' + tempPluralText;
                    } else {
                        $scope.option = $scope.model;

                        var optionExp = $scope.getOptionItem();
                        var displayExp = $scope.getDisplayExpression();

                        var outputItems = [];
                        for (var x = 0; x < $scope.options.length; x++) {
                            $scope.option = $scope.options[x];
                            if ($scope.compare($scope.model, $parse(optionExp)($scope))) {
                                outputItems.push($parse(displayExp)($scope));
                            }
                            outputItems.push();
                        }

                        if (outputItems.length == 1) return outputItems[0];
                        return defaultTitle + ' ' + tempPluralText;
                    }
                }
            };

            $scope.getDisplayExpression = function () {
                return $scope.useDisplayOption ? $scope.display : 'option';
            };

            $scope.generateUniqueId = function() {
                var text = '';
                var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                for (var i = 0; i < 14; i++) {
                    text += possible.charAt(Math.floor(Math.random() * possible.length));
                }
                if ($('#' + text).length) {
                    return $scope.generateUniqueId();
                }
                return text;
            };

            if ($scope.useRandomId) {
                $timeout(function () {
                    $scope.uniqueid = $scope.generateUniqueId();
                    $(document).click(function (event) {
                        if (!$(event.target).closest('#' + $scope.uniqueid).length) {
                            $timeout(function () {
                                if ($scope.showDropDown == true && $scope.close != null) {
                                    $scope.close();
                                }
                                $scope.showDropDown = false;
                            });
                        }
                    });
                });
            } else {
                if (typeof $scope.uniqueid !== 'undefined' && $scope.uniqueid != null && $scope.uniqueid != '') {
                    $(document).click(function (event) {
                        if (!$(event.target).closest('#' + $scope.uniqueid).length) {
                            $timeout(function () {
                                $scope.showDropDown = false;
                            });
                        }
                    });
                } else {
                    $(document).click(function () {
                        $timeout(function () {
                            $scope.showDropDown = false;
                        });
                    });
                    $('.dropdownmenucontainer').click(function (event) {
                        event.stopPropagation();
                    });
                }
            }

            $scope.buttonClick = function(event) {
                var width = $(event.currentTarget).outerWidth();
                if ($scope.showDropDown == true) {
                    $timeout(function() {
                        $scope.showDropDown = false;

                    });
                } else {
                    $timeout(function() {
                        $scope.dropdownStyle = { 'width': width + 'px' }; //force the width of the dropdown container
                        $scope.showDropDown = true;
                    });
                }
            };

            $scope.compare = function (modelItem, optionItem) {
                if ($scope.useCustomCompare) {
                    $scope.option = modelItem;
                    var modelItemOutput = $parse($scope.comparator)($scope);
                    $scope.option = optionItem;
                    var optionItemOutput = $parse($scope.comparator)($scope);
                    return modelItemOutput == optionItemOutput;
                }

                var modelOutput = modelItem;
                var optionOutput = optionItem;
                if ($scope.useModelCompare) {
                    modelOutput = $parse($scope.modelcomparator)($scope);
                }
                if ($scope.useOptionCompare) {
                    optionOutput = $parse($scope.optioncomparator)($scope);
                }
                return modelOutput == optionOutput;
            }

            $scope.indexOfModel = function (optionItem) {
                for (var z = 0; z < $scope.model.length; z++) {
                    if ($scope.compare($scope.model[z], optionItem)) {
                        return z;
                    }
                }
                return -1;
            };

            $scope.setSelectedItem = function (option) {
                if (typeof $scope.model === 'undefined' || ($scope.notArray == false && $scope.model == null)) return false;
                if ($scope.notArray == false) {

                    var index = $scope.indexOfModel(option);

                    if (index < 0 && typeof $scope.maxselected !== 'undefined' && $scope.maxselected != null && $scope.maxselected == $scope.model.length) {
                        //If at max length then remove the lowest item on the stack and add the new item to the top of the stack
                        if ($scope.model.length > 0) {
                            $scope.model.splice(0, 1);
                        }
                        $scope.model.push(option);
                    } else {
                        if (index > -1) {
                            $scope.model.splice(index, 1);
                        } else {
                            $scope.model.push(option);
                        }
                    }

                    if (typeof $scope.maxselected !== 'undefined' && $scope.maxselected != null && $scope.maxselected == $scope.model.length &&
                        typeof $scope.closeonmaxselected !== 'undefined' && ($scope.closeonmaxselected == 'true' || $scope.closeonmaxselected == true)) {
                        $scope.showDropDown = false;
                    }
                } else {
                    
                    if ($scope.compare($scope.model, option) == false) {
                        $scope.model = option;
                        $scope.showDropDown = false;
                    } else {
                        $scope.model = null;
                    }
                }

                //Runs the change function on the next digest
                $timeout(function () {
                    $scope.change();
                });
                return false;
            };

            $scope.isChecked = function (option) {
                if (typeof $scope.model === 'undefined' || ($scope.notArray == false && $scope.model == null)) return false;
                if ($scope.notArray == false) {
                    if ($scope.indexOfModel(option) > -1) {
                        return true;
                    }
                    return false;
                } else {
                    return $scope.compare($scope.model, option);
                }
            };


        }
    }
});
